<template>
  <div class="content">
    <van-nav-bar title="订单详情" @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
      </template>
    </van-nav-bar>
    <div class="order-content">
      <div class="item justify-align">
        <span class="item-name">订单日期</span>
        <div class="item-title" v-if="orderInfo">
          {{orderInfo.created_at}}
        </div>
      </div>
      <div class="item justify-align">
        <span class="item-name">订单状态</span>
        <div class="item-title" v-if="orderInfo">
          <!--        0待支付 1已支付 2已发货 3已收货 10已评价(已完成) 11已取消 12已退款-->
          <span v-if="orderInfo.status==1">已支付</span>
          <span v-else-if="orderInfo.status==2">已发货</span>
          <span v-else-if="orderInfo.status==3">已收货</span>
          <span v-else-if="orderInfo.status==10">已评价(已完成)</span>
          <span v-else-if="orderInfo.status==11">已取消</span>
          <span v-else-if="orderInfo.status==12">已退款</span>
          <span v-else>待支付</span>
        </div>
      </div>
      <div class="item justify-align" v-if="orderInfo.refund != null">
        <span class="item-name">退款状态</span>
        <div class="item-title">
          <span v-if="orderInfo.refund.status==1">审核通过</span>
          <span v-else-if="orderInfo.refund.status==2">审核拒绝</span>
          <span v-else>审核中</span>
        </div>
      </div>
      <div class="item" style="border: none;">
        <span class="item-name">消费项目</span>
        <div class="item-title" style="width: 100%;margin-top: 2.66667vw;">
          <div class="item-title-content" v-for="(item,index) in orderInfo.order_goods" :key="index" @click="goDesGood(item.goods_id)">
            {{item.name}}
            <div class="item justify-align">
              <span class="item-name">商品数量</span>
              <div class="item-title">
                <span style="color: #666;">{{item.number}} x </span>  <span style="color: #F23926;">{{item.price}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item" style="border-bottom: none;padding-top: 0;padding-bottom: 4vw;" v-if="orderInfo">
        <div class="justify-align">
          <div>
            <van-button @click="getQrcode" size="small" class="btn-qrcode" round type="info" v-if="orderInfo.status==1&&orderInfo.refund==null">提货码</van-button>
            <van-button size="small" class="btn-qrcode" style="background: #ffffff;border: 0.26667vw solid #d4d4d4;width:24vw;" @click="clickSalesPop(orderInfo.refund)" round type="info" v-if="(orderInfo.status==1&&orderInfo.refund !== null)||(orderInfo.status==2&&orderInfo.refund !== null)">查看记录</van-button>
          </div>
          <div class="discounts"><span class="pay-txt">优惠</span><span class="price-icon">-￥</span><span class="">{{orderInfo.preferential_amount}}</span></div>
        </div>

        <div class="pay-price"><span class="pay-txt">需支付</span><span class="price-icon">￥</span><span class="price-num">{{orderInfo.payment_price}}</span></div>
      </div>
    </div>
    <div class="address-box left-justifying">
      <img :src="require('../../assets/'+appTheme+'/add_icon.png')" alt="" />
      <div class="add-content" v-if="orderInfo.address">
        <div class="add-name">
          {{orderInfo.address.name}}  {{orderInfo.address.phone}}
        </div>
        <div class="add-txt">{{orderInfo.address.area}}{{orderInfo.address.address}}</div>
      </div>
    </div>
    <div class="" style="margin-top: 2.66667vw" v-if="orderInfo.status==0">
      <van-field
        v-model="orderInfo.message"
        rows="1"
        autosize
        label="订单备注"
        type="textarea"
        placeholder="请填写订单备注"
      />
    </div>
    <div class="" style="margin-top: 2.66667vw" v-else>
      <van-field
        v-model="orderInfo.message"
        rows="1"
        autosize
        disabled
        label="订单备注"
        type="textarea"
        :placeholder="orderInfo.message"
      />
    </div>
    <div class="null-box"></div>
    <div class="btn-list">
      <div class="btn-list-sec justify-align">
        <div class="btn btn-cancel" v-if="orderInfo.status==0" @click="cancelOrder">取消订单</div>
        <div class="btn btn-pay" v-if="orderInfo.status==0" @click="goPay">付款</div>
        <div class="btn btn-pay" :style="{width:orderInfo.refund != null?'100%':'57.33333vw'}" v-if="orderInfo.status==2" @click="takeGoodClick">确定收货</div>
        <div class="btn btn-cancel" :style="{width:orderInfo.refund == null?'100%':'30.66667vw'}" v-if="(orderInfo.status==2&&orderInfo.refund == null)||(orderInfo.status==1&&orderInfo.refund == null)" @click="takeSalesReturn(orderInfo.id)">申请退款</div>
      </div>

    </div>
    <div class="wu-list" v-if="orderInfo.express">
      <div class="wl-title justify-align">
        <span style="margin-left: 0">{{orderInfo.express.name}}</span><span>单号：{{orderInfo.express_no}}</span>
      </div>
      <div class="express-list">
        <div class="express-item" v-for="(item,index) in orderInfo.express_api" :key="index">
          <div class="express-date">{{item.time}}</div>
          <div class="express-context">{{item.context}}</div>
        </div>
      </div>
    </div>
    <!--  弹框-->
    <van-overlay :show="qrcodeShow" @click="qrcodeShow = false">
      <div class="qr_zs_wrapper" @click.stop>
        <div class="block">
          <img :src="qrcodeUrl" alt="" />
          <!--        <span>扫一扫关注智慧健康</span>-->
        </div>

      </div>
    </van-overlay>
    <!--  扫码关注end-->
    <!--  退货中弹框-->
    <van-overlay :show="returnShow" @click="returnShow = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="title">提示 <van-icon @click="returnShow = false" class="icon-colse-span" name="cross" /></div>
          <div class="item-box">
            <div class="item left-justifying" style="align-items: self-start;">
              <span class="title-lf">申请原因：</span>
              <div class="cause-box" style="max-height: 53.33333vw;overflow-y: auto;">
                {{refundItem.reason}}
              </div>
            </div>
            <div class="item left-justifying">
              <span class="title-lf">图片说明：</span>
              <div v-if="refundItem.image_url" class="cause-box-pic" :class="[refundItem.image_url.length==2?'left-justifying':'justify-align']">
                <img :style="{'margin-right': refundItem.image_url.length==2?'2.66667vw':'0'}" v-for="(item,i) in refundItem.image_url" :src="item" :key="i" alt="" />
              </div>
            </div>
            <div class="item left-justifying">
              <span class="title-lf">审核状态：</span>
              <div class="cause-box-sec" style="color: #f12626;">
                <span v-if="refundItem.status==0">审核中</span>
                <span v-if="refundItem.status==1">已通过</span>
                <span v-if="refundItem.status==2">拒绝</span>
              </div>
            </div>
            <div class="item left-justifying">
              <span class="title-lf">平台/商家回复：</span>
              <div class="cause-box-sec" style="max-height: 26.66667vw;overflow-y: auto;width: 62%;">
                {{refundItem.remark}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!--  退货中弹框end-->
  </div>
</template>

<script>
import { orderListDes,orderDel,takeGood,orderOfflineQrcode } from '@/api/order'
import { Dialog } from 'vant';
import QRCode from 'qrcode';
export default {
  name: "des",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      returnShow:false,
      refundItem:'',
      chosenCoupon: -1,
      showList:false,
      address: {
      },
      orderId: '',
      orderInfo: '',
      discountsPrice:0,
      qrcodeShow: false,
      qrcodeUrl: '',

    }
  },
  created() {
    this.orderId = this.$route.query.id
    this.getInfoOrder()
  },
  methods: {
    clickSalesPop(item){
      console.log(item)
      this.refundItem = item
      this.returnShow = true
    },
    takeSalesReturn(id){
      this.$router.push({path:'/orderSalesReturn',query:{id:id}})
    },
    getQrcode(){
      orderOfflineQrcode(this.orderInfo.id).then(res => {
        if(res.code == 200)
        {
          let code = res.data.code
          this.qrCodeClick(code)
        }else {
          this.$toast(res.message)
        }
      })
    },
    qrCodeClick(code){ // 生成二维码
      var id = this.orderId
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/shoper/order/${id}/${code}`  //'https://jpzs-zst.itos.cn/logo.jpg'
      console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
          this.qrcodeShow = false
        } else {
          this.qrcodeUrl = qr;
          // this.$router.push({path:`/shoper/order/${id}/${code}`})
          this.qrcodeShow = true
        }
      });

    },
    goDesGood(id){
      this.$router.push({path:'/goodDetails',query:{id:id}})
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    goPay(){
      var data = JSON.stringify(this.orderInfo)
      this.$router.push({path:'/submitOrder',query: {id:this.orderInfo.id,pay:data}})
    },
    takeGoodClick(id){ // 确定收货
      Dialog.confirm({
        title: '提示',
        message: '是否要确定收货？',
      })
        .then(() => {
          console.log('quedign')
          // on confirm
          takeGood(this.orderInfo.id).then(res => {
            console.log(res)
            if(res.code == 200)
            {
              this.$toast(res.message)
              const secounds = 2
              let num = 0
              const timer = setInterval(() => {
                if(num < secounds) {
                  num++
                }else {
                  clearInterval(timer)

                  this.$router.go(-1);
                }
              }, 1000)// 这里的时间不要忘记，否则没有效果

            }
            else
            {
              this.$toast(res.message)
              // this.$router.push('/');
            }
          })
        })
        .catch(() => {
          // on cancel
        });

    },
    cancelOrder(){
      Dialog.confirm({
        title: '提示',
        message: '是否要取消订单？',
      })
        .then(() => {
          // on confirm
          orderDel(this.orderId).then(res => {
            if(res.code == 200)
            {
              this.$toast(res.message)
              const secounds = 2
              let num = 0
              const timer = setInterval(() => {
                if(num < secounds) {
                  num++
                }else {
                  clearInterval(timer)

                  this.$router.go(-1);
                }
              }, 1000)// 这里的时间不要忘记，否则没有效果
            }
            else
            {
              this.$toast(res.message)
              // this.$router.push('/');
            }
          })
        })
        .catch(() => {
          // on cancel
        });

    },
    getInfoOrder(){
      orderListDes(this.orderId).then(res => {
        if(res.code == 200)
        {
          // console.log(res.data)
          this.orderInfo = res.data
          // var t_price = (parseFloat(this.orderInfo.total) - parseFloat(this.orderInfo.payment_price))
          // console.log('eee',parseFloat(this.orderInfo.total) - parseFloat(this.orderInfo.payment_price))
          // var result = ( parseInt( t_price * 100 ) / 100 ).toFixed(2); // 保留2位小数且不四色五入
          // this.discountsPrice = result
          // let lastp = cal.accSub(this.orderInfo.total, this.orderInfo.payment_price); // 减法
          // this.discountsPrice = lastp
          // console.log(lastp)
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    width: 80%;margin-top: -90px;
    max-height: 80%;overflow-y: auto;
    background-color: #fff;border-radius: 10px;
    .title{
      text-align: center;padding: 20px 20px;position: relative;
      .icon-colse-span{
        position: absolute;right: 20px;top: 20px;font-size: 40px;color: #999999;
      }
    }
    .item-box{
      padding: 20px;
      .item{
        padding: 10px 0;
        .title-lf{
          color: #646566;
        }
        .cause-box{
          width: 72%;
        }
        .cause-box-pic{
          width: 72%;
          img{
            width: 120px;height: 120px;
          }
        }
      }
    }
  }
}
.qr_zs_wrapper{
  //display: flex;
  //align-items: center;
  //justify-content: center;text-align: center;
  //height: 100%;
  .block {
    width: 550px;
    //padding: 5px 0;
    //background-color: #fff;
    //border-radius: 8px;
    text-align: center;
    margin: 330px auto 0;
    img{
      width: 500px;
      height: 500px;display: block;
      margin: 0 auto;border-radius: 10px;
    }
  }

}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.btn-qrcode{
  background: #FDD80D;color: #333333;border: none;width: 160px;font-weight: bold;font-size: 28px;
}
.wu-list{
  background: #ffffff;padding: 0 24px;margin-top: 20px;padding-bottom: 160px;
  .wl-title{
    padding: 30px 0;border-bottom: 1px solid #E5E5E5;font-size: 30px;text-align: left;
    span{margin-left: 20px;display: inline-block;}
  }
  .express-list{
    text-align: left;
    .express-item{padding: 10px 0;margin-top: 15px;
     .express-context{
       line-height: 45px;margin-top: 10px;font-size: 26px;
     }
    }
  }
}
.van-nav-bar .van-icon {
  color: #333333;
}
.btn-list{
  position: fixed;bottom: 50px;left: 0;width: 100%;
  .btn{
    border-radius: 45px;height: 90px;line-height: 90px;text-align: center;color: #282828;font-size: 38px;
  }
  .btn-cancel{
    width: 230px;background: #F5F5F3;
    border: 2px solid #C8C8C8;
  }
  .btn-pay{
    background: #FDD80D;width: 436px;
  }
  .btn-list-sec{
    margin: 0 24px;
  }
}
.order-content{
  background: #ffffff;padding: 0 24px;
  .item{
    padding: 30px 0;border-bottom: 1px solid #E5E5E5;
    .item-name{
      font-weight: bold;
      color: #282828;
      font-size: 26px;
    }
    .item-title{
      width: 70%;text-align: right;font-weight: 400;
      color: #000000;font-size: 24px;
      .item-title-content{
        text-align: left;margin-bottom: 20px;
      }
    }
    .discounts{
      text-align: right;padding-bottom: 20px;font-size: 28px;
      .pay-txt{
        margin-right: 20px;font-size: 24px;
      }
      .price-icon{
        font-size: 24px;
      }
    }
    .pay-price{
      text-align: right;font-weight: 400;
     font-size: 30px; color: #F23926;
      .price-icon{
        font-size: 24px;
      }
      .pay-txt{
        color: #000000;margin-right: 20px;font-size: 24px;
      }
      .price-num{
        font-weight: bold;
      }
    }
  }

}
.address-box{
  background: #ffffff;padding: 20px 24px;margin-top: 20px;
  img{
    width: 26px;height: auto;display: inline-block;
  }
  .add-content{
    .add-name{
      font-size: 30px;font-weight: bold;
      color: #000000;margin-bottom: 10px;
    }
    text-align: left;margin-left: 30px;font-size: 24px;color: #000000;
  }
}
</style>
